<!--
 Page: payment-day.vue [458006]
 From: 2025-04-27 10:33:08 Ywr
 Remark: 住院日清单
-->
<template>
  <div class="sn-f-b-s payment-day">
    <!-- 导航栏 -->
    <sn-navigator id="FYCX" :initial="perpetual.FUNCTION_ID_ZYRQD"></sn-navigator>
    <div class="sn-f-1 sn-f-s-1 sn-f-col-b-s payment-day-region">
      <!-- 面包屑 -->
      <sn-breadcrumb :breadcrumb="[{ title: $sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_ZYRQD) }]"></sn-breadcrumb>
      <!-- 空白区域 -->
      <div class="sn-f-1 sn-f-s-1 payment-blank">
        <!-- 住院人 -->
        <div class="sn-f-s-0 sn-f-e-c sn-header-patient">
          <div class="sn-f-s-c region">
            <div class="sn-f-s-c patient-title">
              <div class="required">*</div>
              <div>住院人：</div>
            </div>
            <div v-if="!$sn.validate.array(patientArray)" @click="handlePatientInfo();">
              暂未获取到住院人，<span class="sn-pointer sn-fc-main">点击刷新</span>
            </div>
            <template v-else-if="patientArray.length === 0">
              <div @click="navigateUrl(isOpenSingleCard ? 'addition-patient' : '/patient/out/homepage');">
                暂无住院人，<span class="sn-pointer sn-fc-main">点击添加</span>
              </div>
            </template>
            <template v-else>
              <el-select :value="selectedPatient.patientId" @change="changePatient">
                <el-option :key="patient.patientId" :label="patient.patientName" :value="patient.patientId" v-for="patient in patientArray"></el-option>
              </el-select>
            </template>
          </div>
          <div class="sn-f-s-c region" v-if="selectedPatient.patientId">
            <div class="sn-f-s-c patient-title">
              <div class="required">*</div>
              <div>住院号：</div>
            </div>
            <div v-if="!outCardSerial" @click="navigateUrl('addition-card');">
              {{ outCardSerialFormat }}，<span class="sn-pointer sn-fc-main">点击绑定</span>
            </div>
            <div v-else>
              <el-input readonly="readonly" v-model="outCardSerialFormat"></el-input>
            </div>
          </div>
          <div class="sn-f-s-c region">
            <div class="sn-f-s-c patient-title">
              <div class="required">*</div>
              <div>查询日期：</div>
            </div>
            <el-date-picker v-model="searchDate" type="date" placeholder="请选择查询日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
          </div>
          <div class="sn-f-s-c region">
            <el-button type="primary" @click="searchBtn">查询</el-button>
          </div>
        </div>
        <!-- 费用信息 -->
        <template v-if="!$sn.validate.empty(handlePayment)">
          <div class="total-title">消费总金额：{{$sn.format.priceFormat(totalCost, 2)}}元</div>
          <div class="sn-table">
            <table>
              <thead>
                <tr>
                  <th>序号</th>
                  <th>就诊人</th>
                  <!-- <th>手机号</th> -->
                  <th>性别</th>
                  <th>类别</th>
                  <!-- <th>消费时间</th> -->
                  <th>单价（元）</th>
                  <th>数量</th>
                  <th>金额（元）</th>
                  <!-- <th>操作</th> -->
                </tr>
              </thead>
              <tbody>
                <tr :key="index" v-for="(payment, index) in handlePayment">
                  <td>{{ index + 1 }}</td>
                  <td>{{selectedPatient.patientName}}</td>
                  <!-- <td>{{$sn.encrypted.phone(selectedPatient.patientPhone)}}</td> -->
                  <td>{{$sn.format.sex(selectedPatient.patientSex)}}</td>
                  <td>{{payment.chargeName}}</td>
                  <!-- <td>{{payment.chargeTime}}</td> -->
                  <td>{{payment.price === 0 ? '0.00' : $sn.format.priceFormat(payment.price, 2)}}</td>
                  <td>{{payment.amount}}</td>
                  <td>{{payment.totalFee === 0 ? '0.00' : $sn.format.priceFormat(payment.totalFee, 2)}}</td>
                  <!-- <td class="sn-pointer sn-fc-main" @click="navigateUrl('/query/out/payment/detail', payment, {type: paymentType});">查看详情</td> -->
                </tr>
              </tbody>
            </table>
          </div>
        </template>
        <template v-else>
          <sn-no-data></sn-no-data>
          <!-- <div class="sn-f-c-c prompt-message"></div> -->
        </template>
      </div>
      <div class="sn-f-s-0 sn-f-e-c pagination">
        <div class="sn-f-c-c sn-pointer pagination-interaction" :class="{'pagination-actived': pageCount > 1}" @click="exchangePage('1');">上一页</div>
        <div>当前第<span class="sn-fc-main sn-ph-10">{{ pageCount }}</span>页</div>
        <div class="sn-f-c-c sn-pointer pagination-interaction"
        :class="{'pagination-actived': isResult || !$sn.validate.empty($sn.format.group(paymentInfo, perpetual.PAGINATION_SIZE)[pageCount])}" @click="exchangePage('2');">下一页</div>
      </div>
      <create-patient v-if="exhibitionCreatePatient" @sendBack="sendBackCreatePatient"></create-patient>
      <bind-card v-if="exhibitionBindCard" :patientId="selectedPatient.patientId || ''" :type="isOpenSingleCard ? '1' : paymentType" @sendBack="sendBackBindCard"></bind-card>
    </div>
  </div>
</template>

<script type="text/javascript">
import Swagger from '@/common/utils/swagger';
import * as Messages from '@/common/utils/messages';
import * as Initial from '@/common/utils/initial';
import * as Tools from '@/common/utils/tools';
import PatientShareMixin from '@/pages/patient/patient-share-mixin';
import self from '@/common/utils/global-config';

export default {
  mixins: [PatientShareMixin],
  components: {
    'create-patient': () => import('@/components/create-patient'),
    'bind-card': () => import('@/components/bind-card')
  },

  data() {
    return {
      patientArray: [], // 住院人列表
      selectedPatient: {}, // 当前住院人
      outCardSerial: '', // 住院号
      outCardSerialFormat: '', // 住院号格式化
      searchDate: null, // 开始日期
      paymentInfo: [], // 费用信息
      pageCount: 1, // 当前页
      isResult: true, // 是否查询到数据
      totalCost: 0, // 总费用
      exhibitionCreatePatient: false,
      exhibitionBindCard: false,
      isOpenSingleCard: self.$sn.getConfig('isOpenSingleCard')
    };
  },

  computed: {
    // 处理费用信息
    handlePayment() {
      let handle = [];
      if (this.paymentInfo.length > 0) handle = this.$sn.format.group(this.paymentInfo, this.perpetual.PAGINATION_SIZE)[this.pageCount - 1];
      return handle;
    }
  },

  watch: {
    selectedPatient: async function(patient) {
      this.isResult = true;
      this.paymentInfo = [];
      this.pageCount = 1;
      if (patient.patientId) {
        const handle = await Tools.handlePatientInfo(patient, '2');
        if (handle.code >= 0) {
          this.outCardSerial = handle.data.no;
          this.outCardSerialFormat = handle.data.caption;
          if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL && handle.code === 0) this.outCardSerialFormat = patient.idCardEncrypt;
        }
        if (this.outCardSerial) {
          if (this.searchDate) this.searchBtn();
        }
      }
    },
    pageCount: {
      handler: function(n, o) {
        if ((n >= o || !this.$sn.validate.empty(o)) && this.$sn.validate.empty(this.$sn.format.group(this.paymentInfo, this.perpetual.PAGINATION_SIZE)[n])) {
          this.searchBtn();
        }
      },
      immediate: true
    }
  },

  created() {
    this.funLoad();
  },

  methods: {
    funLoad() {
      document.title = this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_ZYRQD);
      this.$route.meta.title = this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_ZYRQD);
      this.handlePatientInfo();
    },
    // 处理就诊人信息
    async handlePatientInfo() {
      this.$sn.assembly.loading(true);
      await Initial.obtainPatientInfoByCondition();
      this.$sn.assembly.loading(false);
      // 住院人 - 含有住院号
      if (this.isOpenSingleCard) this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      else this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList').filter(item => item.inCardNo);
      if (this.patientArray.length > 0) {
        if (this.isOpenSingleCard) this.selectedPatient = this.$sn.utils.getCurrentPatient() || this.patientArray[0];
        else this.selectedPatient = this.patientArray[0];
      }
    },
    // 切换就诊人
    changePatient(id) {
      if (id) {
        this.selectedPatient = this.patientArray.find(item => item.patientId === id);
        this.$sn.utils.setHospitalLocalStorage('CurrentPatient', this.selectedPatient);
      }
    },
    // 添加就诊人回调
    sendBackCreatePatient(type) {
      if (type) this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      this.exhibitionCreatePatient = false;
    },
    // 绑卡回调
    sendBackBindCard(type, patient) {
      if (type) {
        this.selectedPatient = patient;
        this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      }
      this.exhibitionBindCard = false;
    },
    // 查询门诊费用
    searchBtn() {
      if (!this.outCardSerial) {
        const compare = {
          [this.perpetual.HOSPITAL_ID_SDSL]: 'PATIENT043'
        };
        this.$sn.assembly.modal({
          caption: Messages[compare[this.$sn.utils.getHospitalId()] || 'RECHARGE012'],
          success: (modal) => {
            if (modal.confirm) this.navigateUrl('addition-card');
          }
        });
      }
      else {
        if (this.$sn.validate.empty(this.searchDate)) {
          this.getShowToast(this.$sn.format.caption(Messages.SEARCH011, ['查询日期']));
          return false;
        }

        const params = {
          url: this.$sn.format.caption(Swagger.getPaymentInDayTable, [this.$sn.utils.getHospitalId()]),
          query: {
            cardNo: this.outCardSerial,
            endDate: this.searchDate,
            hosId: this.$sn.utils.getHospitalId(),
            page: this.pageCount,
            patId: this.selectedPatient.patientId,
            platformId: this.$sn.utils.getPlatformType(),
            platformUserId: this.$sn.utils.getOpenId(),
            size: this.perpetual.PAGINATION_SIZE,
            startDate: this.searchDate
          },
          header: true
        };
        this.status = 'loading';
        this.$sn.assembly.loading(true);
        this.$sn.utils.ordinaryRequest(params).then(result => {
          this.$sn.assembly.loading(false);
          if (result && result.code === 0 && result.data && result.data.length > 0) {
            this.isResult = result.data.length === this.perpetual.PAGINATION_SIZE;
            if (this.pageCount === 1) {
              this.paymentInfo = result.data;
              this.totalCost = result.totalFee || 0;
            }
            else this.paymentInfo = this.paymentInfo.concat(result.data);
          }
          else this.isResult = false;
        });
      }
    },
    // 1：上一页；2：下一页
    exchangePage(type) {
      if (type === '1') {
        if (this.pageCount > 1) this.pageCount--;
      }
      else if (type === '2') {
        if (this.isResult || !this.$sn.validate.empty(this.$sn.format.group(this.paymentInfo, this.perpetual.PAGINATION_SIZE)[this.pageCount])) this.pageCount++;
      }
    },
    // 单纯的弹窗显示信息
    getShowToast(caption) {
      this.$sn.assembly.toast({
        caption: caption
      });
    },
    // 跳转页面
    navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === 'addition-patient') this.exhibitionCreatePatient = true;
      else if (url === 'addition-card') this.exhibitionBindCard = true;
      else {
        this.$router[type]({
          path: url,
          query: params
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.payment-day {
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: relative;

  &-region {
    overflow: hidden;
    height: 100%;

    .payment-blank {
      overflow: hidden;
      width: 100%;
      height: 100%;
      padding-right: 20px;
      display: flex;
      flex-direction: column;

      ::v-deep .sn-header-patient {
        .el-date-editor.el-input {
          width: 140px;
        }

        .el-input--suffix .el-input__inner {
          padding-right: 0;
        }
      }

      .el-button {
        padding: 10px 20px;
        background-color: $main1;
        border-color: $main1;
      }

      .total-title {
        font-size: 16px;
        margin: 0 20px 20px;
      }

      .prompt-message {
        font-size: 16px;
        color: $red1;
        padding: 10px 0;
      }
    }

    .pagination {
      @include fs(16);

      width: 100%;
      height: 40px;
      margin: 20px 0 40px;

      &-interaction {
        height: 40px;
        color: $text6;
        border: 1px solid $border1;
        border-radius: 5px;
        padding: 0 20px;
        margin: 0 10px;

        &:last-child {
          margin-right: 20px;
        }
      }

      &-actived {
        color: $text1;

        &:hover {
          background-color: $main4;
          color: $main3;
          border: 1px solid $main3;
        }
      }
    }
  }
}
</style>
